// extracted by mini-css-extract-plugin
module.exports = {"block":"_8SwLU","show":"ygbpo"};